import { CheckCircle } from 'lucide-react';

interface StepIndicatorProps {
  step: number;
  currentStep: number;
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({
  step,
  currentStep,
  label,
  onClick,
  disabled = false,
}) => {
  const textColor =
    step < currentStep
      ? 'text-lime-600'
      : currentStep === step
      ? 'text-blue-600'
      : 'text-gray-400';
  const borderColor =
    step < currentStep
      ? 'border-lime-600'
      : currentStep === step
      ? 'border-blue-600 bg-blue-100'
      : 'border-gray-300';
  const bgColor =
    step < currentStep
      ? 'bg-green-100'
      : currentStep === step
      ? 'bg-blue-100'
      : 'bg-gray-100';
  const cursorStyle = disabled ? 'cursor-not-allowed' : 'cursor-pointer';
  const handleClick = () => {
    if (!disabled) {
      onClick();
    }
  };

  return (
    <div
      className={`${bgColor} pl-2 py-1.5 pr-2 sm:pr-4 rounded-full ${cursorStyle} flex items-center ${textColor}`}
      onClick={handleClick}
    >
      <div
        className={`w-8 h-8 rounded-full flex items-center justify-center border-2 ${borderColor}`}
      >
        {currentStep > step ? <CheckCircle className="w-6 h-6" /> : step}
      </div>
      <span className="ml-2 hidden sm:block">{label}</span>
    </div>
  );
};

export default StepIndicator;
